import React, { Component } from 'react'
import DetailPresenter from './DetailPresenter'
import { moviesApi, tvApi } from '../../api'

export default class DetailContainer extends Component {
    state = {
        result: null,
        credits: null,
        error: null,
        loading: true
    }

    async getData(parsedId, type, push) {
        try {
            if (!isNaN(parsedId) && type === 'movie') {
                const { data: result } = await moviesApi.movieDetail(parsedId)
                const { data: { cast: credits } } = await moviesApi.movieCredits(parsedId)
                const { data: recommendations } = await moviesApi.movieRecommendations(parsedId)
                return this.setState({ result, credits, recommendations, type })
            }
            if (!isNaN(parsedId) && type === 'show') {
                const { data: result } = await tvApi.tvDetail(parsedId)
                const { data: { cast: credits } } = await tvApi.tvCredits(parsedId)
                const { data: { imdb_id } } = await tvApi.tvImdb(parsedId)
                const { data: recommendations } = await tvApi.tvRecommendations(parsedId)
                return this.setState({ result, credits, imdb_id, recommendations, type })
            }
            return push('/')
        } catch (error) {
            this.setState({ error: 'error!' })
            return push('/')
        } finally {
            this.setState({ loading: false })
        }
    }

    async componentDidMount() {
        const { match: { params: { id, type } }, history: { push } } = this.props
        const parsedId = parseInt(id)
        this.getData(parsedId, type, push)
    }

    async componentDidUpdate(prevProps) {
        const { match: { params: { id: prevId, type: prevType } } } = prevProps
        const { match: { params: { id, type } }, history: { push } } = this.props
        if (prevId !== id || prevType !== type) {
            const parsedId = parseInt(id)
            this.getData(parsedId, type, push)
        }
    }

    render() {
        const { result, credits, imdb_id, error, loading, recommendations, type } = this.state
        return (
            <DetailPresenter type={type} imdb_id={imdb_id} result={result} error={error} loading={loading} credits={credits} recommendations={recommendations} />
        )
    }
}

